import moment from 'moment-timezone';
import { Geolocation } from '@capacitor/geolocation';
import { types } from 'utils';
import { parsePhoneNumber } from 'awesome-phonenumber';
import { Capacitor } from '@capacitor/core';
import { Haptics } from '@capacitor/haptics';

moment.tz.setDefault('Africa/Lagos');

export const config = {
    platform: 'apk',
}

export const app = {
    dbpref: 'cr_rid_',
    version: require('../../package.json').version,
}

export const dates = {
    yr: moment().format('YYYY'),
}

export const isMobile = Capacitor.isNativePlatform();

// ::: storage
export const setStorage = (key: string, value: any) => {
    if (key && value) {
        localStorage.setItem(app.dbpref + key, value);
    }
}
export const getStorage = (key: string) => {
    const value = localStorage.getItem(app.dbpref + key);
    return value || '';
}
export const setStorageJson = (key: string, value: any, onOK: any = null) => {
    if (key && value) {
        localStorage.setItem(app.dbpref + key, JSON.stringify(value));
        onOK && onOK();
    }
}
export const getStorageJson = (key: string) => {
    if (key) {
        const value = localStorage.getItem(app.dbpref + key) || '';
        return isJson(value) ? JSON.parse(value) : '';
    }
}
export const delStorage = (key: string) => {
    if (key) {
        localStorage.removeItem(app.dbpref + key);
    }
}


export const inArray = (needle: any, haystack: any): boolean => {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
        if (haystack[i] === needle) return true;
    }
    return false;
}
export const mergeObj = (obj: any, src: any) => {
    for (var key in src) {
        if (src.hasOwnProperty(key)) obj[key] = src[key];
    }
    return obj;
}
export const getFileExtension = (filename: string) => {
    var ext = /^.+\.([^.]+)$/.exec(filename);
    return ext === null ? '' : ext[1];
}

export const redirect = (to: any) => {
    window.location = to;
}

export const generateOptions = (length: number, step = 1) => {
    const arr = [];
    for (let value = 0; value < length; value += step) {
        arr.push(value);
    }
    return arr;
};

export const numberFormat = (number: number, decimal: number = 0) => {
    // eslint-disable-next-line no-useless-escape
    number = +(number || 0).toString().replace(/[^0-9\./]/g, '');
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: decimal }).format(number);
}

export const format = {
    phoneNumber: (a: string) => parsePhoneNumber(a).number?.national || a,
    number: (number: number, decimal = 0) => {
        number = number || 0;
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: decimal,
        }).format(number);
    },
    currency: (amount: number) => {
        return `₦ ${format.number(+amount, 2)}`;
    },
};

export const loading = async (content: any) => {
    const loading = document.createElement('ion-loading');
    loading.message = content;
    loading.duration = 2000;
    loading.cssClass = 'custom-loading';

    document.body.appendChild(loading);
    await loading.present();
    return loading;
}

export const presentAlert = async (conf: any = {}) => {
    const alart = document.createElement('ion-alert');
    alart.header = 'Alert';
    alart.subHeader = 'Important message';
    alart.message = 'This is an alart!';
    alart.buttons = ['OK'];

    document.body.appendChild(alart);
    await alart.present();
}

export const toast = (message: string, position: any = 'bottom', cssClass: string = '') => {
    const toast = document.createElement('ion-toast');
    toast.message = message;
    toast.position = position;
    toast.cssClass = cssClass;
    toast.duration = 2000;

    document.body.appendChild(toast);
    return toast.present();
}

export const isJson = (str: any) => {
    try {
        JSON.parse(str);
        return true;
    } catch (error) {
        return false;
    }
}

export const togglePasswordShow = (e: any) => {
    var x = document.getElementById(e) as HTMLInputElement;
    if (x) {
        if (x.type === 'password') {
            x.setAttribute('type', 'text');
        } else {
            x.setAttribute('type', 'password');
        }
    }
}

export const cartTotal = (items: any) => {
    let total = 0;
    items.forEach((item: any) => {
        let price = item.price;
        Object.keys(item.product_options).forEach(po => {
            if (item.product_options[po].price > 0) {
                price = item.product_options[po].price;
            }
        });
        let paidPrice = (item.paidSides || []).length && item.paidSides.reduce(function (sum: number, ps: any) {
            return sum + ps.price;
        }, 0);
        total = total + ((price + paidPrice) * (item.quantity || 1));
    });
    return total;
}

export const distanceMatrix = (pointA: { x: number; y: number; }, pointB: { x: number; y: number; }, onlyNumber: boolean = false) => {
    var lat1 = pointA.x;
    var lng1 = pointA.y;
    var lat2 = pointB.x;
    var lng2 = pointB.y;
    if ((lat1 === lat2 && lng1 === lng2) || (!lat1 || !lat2 || !lng1 || !lng2)) {
        return onlyNumber ? 0 : '-- km';
    } else {
        var radlat1 = (Math.PI * lat1) / 180;
        var radlat2 = (Math.PI * lat2) / 180;
        var theta = lng1 - lng2;
        var radtheta = (Math.PI * theta) / 180;
        var dist: number =
            Math.sin(radlat1) * Math.sin(radlat2) +
            Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = +(((dist * 180) / Math.PI) * 60 * 1.1515 * 1.609344).toFixed(1);
        return onlyNumber ? dist : `${dist} km`;
    }
}

export const prepTime = (preparationTime: string) => {
    if (preparationTime === '00:00:00') {
        return 'Ready immediately';
    }
    return `Ready in ${`${moment.duration(preparationTime).asMinutes()} minutes`}`;
}

// export const datesBetween = (startDate: any, endDate: any, format = 'YYYY-MM-DD') => {
//     var dates = [];
//     var currentDate = startDate;
//     var addDays = function (days) {
//         var date = new Date(this.valueOf());
//         date.setDate(date.getDate() + days);
//         return date;
//     };
//     while (currentDate <= endDate) {
//         var date = moment(currentDate).format(format);
//         if (!dates.includes(date)) {
//             dates.push(date);
//         }
//         currentDate = addDays.call(currentDate, 1);
//     }
//     return dates;
// };

export const myCurrentLocation = async () => {
    return new Promise(async (resolve) => {
        if (isMobile) {
            const status = await Geolocation.requestPermissions();
            if (status.coarseLocation === 'granted' || status.location === 'granted') {
                Geolocation.getCurrentPosition().then(geo => {
                    resolve({
                        x: geo.coords.latitude,
                        y: geo.coords.longitude,
                    });
                }).catch(e => {
                    console.log('getCurrentPosition error: ', e);
                });
            }
        } else {
            navigator.geolocation.getCurrentPosition((geo) => {
                resolve({
                    x: geo.coords.latitude,
                    y: geo.coords.longitude,
                });
            }, (e) => {
                console.info('getCurrentPosition error: ', e);
            });
        }
    });
}

export const versionBreak = (v: string) => {
    const vv = v ? Number(v.split('.').join('')) : 0;
    return +(vv.toString().length < 4 ? `${vv}0` : vv);
}

export const isLocal = window.location.hostname === 'localhost';
export const isStaging = window.location.hostname === 'cr-rider.tomati.app';
export const isLocalOrStaging = isLocal || isStaging;

export const playNotificationSound = (time_in_milisec = 2000, attr = { muted: false, loop: true }): Promise<boolean> => {
    // let beep = new Audio(audio);
    // beep.loop = true;
    // beep.play();
    // setTimeout(() => beep.pause(), time_in_milisec);
    return new Promise((resolve) => {
        const beep = document.getElementById('playNotificationAudio') as HTMLAudioElement;
        beep.loop = attr.loop;
        beep.muted = attr.muted;
        beep.play().then(() => {
            setTimeout(() => beep.pause(), time_in_milisec);
            resolve(true);
        }).catch(e => {
            resolve(false);
        });
    });
}

export const secondsUntil = (futureDate: string) => {
    const endDate = moment(futureDate).valueOf();
    const nowTime = moment().valueOf();
    const diff = endDate - nowTime;
    // console.log({ futureDate }, futureTime > nowTime, moment(futureTime).format('LLL'), moment().format('LLL'),);

    return Math.floor(diff / 1000);
}

export const ucWords = (string: string) => {
    return string.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });
}

export const mapUser = (user: types.User) => {
    const settings = getStorageJson('settings') || {};
    const roles = settings.roles;
    const countries = settings.countries as types.Country[];
    if (user.id) {
        user['role'] = roles.find((r: any) => r.id === user.roleId);
        // @ts-ignore
        user['country'] = countries.find(c => c.code === user.country);
    }
    return user;
}

export const sleep = (seconds: number = 1) =>
    new Promise((resolve) => setTimeout(resolve, seconds * 1000));

export const vibrate = async () => {
    if (isMobile) {
        const mini = async () => {
            await Haptics.vibrate({ duration: 300 });
            await sleep(0.1);
            await Haptics.vibrate({ duration: 300 });
            await sleep(0.2);
            await Haptics.vibrate({ duration: 300 });
            await sleep(0.5);
            await Haptics.vibrate({ duration: 400 });
            await sleep(0.1);
            await Haptics.vibrate({ duration: 300 });
            await sleep(0.1);
            await Haptics.vibrate({ duration: 500 });
            await sleep(0.2);
            await Haptics.vibrate({ duration: 200 });
        }
        await mini();
        await mini();
        await mini();
    }
}